import { instance } from './index';

export const airportFulePriceAPI = {
  uploadFuelPrices: (data) => instance.post('talon-fuel-price/upload', data),
}